 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import FOREWORDBYSTEPHANIEMFREEMAN from '@/components/forewordbystephaniemfreeman'
 import NKSTRIBECALLEDSUCCESS from '@/components/nkstribecalledsuccess'
 import CONTENTS from '@/components/contents'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import LESSONINFLEXIBILITY from '@/components/lessoninflexibility'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import CHAPTER011 from '@/components/chapter011'
 import CHAPTER012 from '@/components/chapter012'
 import TRANSFORMATIONBYNALEIGHNAKAI from '@/components/transformationbynaleighnakai'
 import LOVINGMEFORME from '@/components/lovingmeforme'
 import MYTIMEINTHESUN from '@/components/mytimeinthesun'
 import KINGOFDEVON from '@/components/kingofdevon'
 import KINGOFDURABIA from '@/components/kingofdurabia'
 import THEMERRYHEARTSINSPIRATIONALSERIES from '@/components/themerryheartsinspirationalseries'
 import ALSOBYNALEIGHNAKAI from '@/components/alsobynaleighnakai'
 import INTRODUCING from '@/components/introducing'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/acknowledgments",
 			"name" : "acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js